<template>
  <div class="foot">
    <van-tabbar v-model="active" safe-area-inset-bottom route active-color="#ee0a24" inactive-color="#000">
      <!-- 首页 -->
      <van-tabbar-item replace :to="homePath">
        <div class="t-a-c">
          <van-icon name="home-o" size="1.5rem" />
        </div>
        <div class="t-a-c mt">
          首页
        </div>
      </van-tabbar-item>
      
      <!-- 分类（可选显示） -->
      <van-tabbar-item v-if="showCategory" replace to="/Classification">
        <div class="t-a-c">
          <van-icon name="apps-o" size="1.5rem" />
        </div>
        <div class="t-a-c mt">
          分类
        </div>
      </van-tabbar-item>
      
      <!-- 福利卡 -->
      <van-tabbar-item replace :to="cardViewsPath">
        <div class="t-a-c">
          <van-icon name="point-gift-o" size="1.5rem" />
        </div>
        <div class="t-a-c mt">
          福利卡
        </div>
      </van-tabbar-item>
      
      <!-- 购物车 -->
      <van-tabbar-item replace to="/myCart">
        <van-badge max="20">
          <div class="t-a-c">
            <van-icon name="shopping-cart-o" size="1.5rem" />
          </div>
          <div class="t-a-c mt">
            购物车
          </div>
        </van-badge>
      </van-tabbar-item>
      
      <!-- 我的 -->
      <van-tabbar-item replace to="/AllMy">
        <div class="t-a-c">
          <van-icon name="contact" size="1.5rem" />
        </div>
        <div class="t-a-c mt">
          我的
        </div>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "AllNav",
  props: {},
  data() {
    return {
      active: 0,
      badge: 3,
      cacheVersion: 0, // 用于强制更新 computed 属性
    };
  },
  components: {},
  methods: {
    handleStorageChange(e) {
      if (e.key === 'mallSource') {
        this.cacheVersion++
      }
    },
    handleMallSourceChange() {
      this.cacheVersion++
    },
    handleCardChange() {
      this.cacheVersion++
    }
  },
  mounted() { 
    // 监听 localStorage 变化（通过自定义事件，跨标签页）
    window.addEventListener('storage', this.handleStorageChange)
    // 监听自定义事件（用于同标签页内通知）
    window.addEventListener('mallSourceChange', this.handleMallSourceChange)
    window.addEventListener('cardChange', this.handleCardChange)
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleStorageChange)
    window.removeEventListener('mallSourceChange', this.handleMallSourceChange)
    window.removeEventListener('cardChange', this.handleCardChange)
  },
  computed: {
    // 判断当前是否为礼包商城（从缓存读取，依赖 cacheVersion 触发更新）
    isGiftPackageMall() {
      // 访问 cacheVersion 确保响应式
      this.cacheVersion
      return localStorage.getItem('mallSource') === 'giftPackage'
    },
    // 当前福利卡是否有首页
    currentCardHasHome() {
      this.cacheVersion
      return localStorage.getItem('homeShow') === '1'
    },
    // 首页路径：礼包商城 → 礼包首页；有首页 → HomeNew；无首页 → GoodsList
    homePath() {
      if (this.isGiftPackageMall) return '/GiftPackageHome'
      return this.currentCardHasHome ? '/HomeNew' : '/GoodsList'
    },
    // 是否显示分类按钮：礼包商城不显示，福利商城显示
    showCategory() {
      return !this.isGiftPackageMall
    },
    // 福利卡路径：礼包商城需要传递 ticketType=E6
    cardViewsPath() {
      if (this.isGiftPackageMall) {
        return {
          path: '/AllCardViews',
          query: {
            ticketType: 'E6'
          }
        }
      }
      return '/AllCardViews'
    }
  },
  watch: {},
};
</script>

<style lang='scss' scoped>
.foot {
  .iconfont {
    font-size: 1.3rem;
  }
}

.mt {
  margin-top: 0.2rem;
  font-size: 0.8rem;
}

.van-tabbar {
  height: 4rem;
}
</style>